import script from "./EditCalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./EditCalendarView.vue?vue&type=style&index=0&id=4378c672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4378c672"]])

export default __exports__